module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_8.0d756b0d.png";